import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/Specializations.css';

function ITAndCyberLaw() {

  useEffect(() => {
    document.title = "It and Cyber Law - Legal Trails";  // Set Page Title
  }, []);

  return (
    <>
     <Navbar />
    <div className="law">
     
      <section className="specializations-detail">
        <div className="container">
          <div className="header-image">
            
          <img 
            src="/It.jpg" 
            alt="IT and Cyber Law" 
            loading="lazy" 
            onLoad={(e) => e.target.style.opacity = 1}
            style={{ opacity: 0, transition: "opacity 0.3s ease-in-out" }} 
          />


          </div>
          
          <div className="content">
            <p>
              In today’s digital age, IT and cyber law are essential areas of practice that address the legal aspects of technology, data protection, and online activities. At Legal Trails, we offer specialized legal services to help clients navigate the complexities of IT and cyber law, ensuring compliance and safeguarding their interests in the digital realm. Our expertise includes providing legal advice on technology transactions, such as software licensing, cloud computing, and IT outsourcing agreements. We assist clients in complying with data protection laws and regulations, including GDPR and CCPA, and handle cybersecurity matters, including incident response, data breach notifications, and risk management. Additionally, we represent clients in disputes related to technology and cyber law, including intellectual property issues, online defamation, and e-commerce disputes. Our team is dedicated to advising clients on regulatory compliance and risk management in this rapidly evolving field, empowering them to thrive in the digital landscape.
            </p>
            <div className="button-container">
              <Link to="/contact">
                <button>Contact Us</button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      
    </div>
    <Footer />
    </>
  );
}

export default ITAndCyberLaw;
